import React from 'react';

const Footer = () => {
    return (
        <div className="w-full flex justify-around mt-10 font-mono text-sm">
            <p className="text-neutral-grayish-blue">Challenge by <a href="https://www.frontendmentor.io/solutions/interactive-comments-section-solution-WyM5FxzOC" className="text-primary-moderate-blue underline">FrontEnd Mentor</a></p>
            <p className="text-neutral-grayish-blue">Coded by <a href="https://github.com/sazzad4677"  className="text-primary-moderate-blue underline">Sazzad</a></p>
        </div>
    );
};

export default Footer;